module.exports = __webpack_public_path__ + "img/download.78cf4ff0.svg";